import { Row, Col} from "antd";
import { FormikValues } from "formik";
import React, { useEffect, useState } from "react";
import { MetaModel } from "../../../models/meta.model";
import { ApiRoutes } from "../../../routes/routeConstants/apiRoutes";
import MetaService from "../../../services/MetaService/meta.service";
import ButtonComponent from "../../../shared/components/ButtonComponent";
import TableSearchFilterComponent, {
  FilterData,
} from "../../../shared/components/TableSearchFilterComponent";
import {
  ActivityStatus,
  ActivityTypes,
} from "../../definitions/activity.definition";
import MaerskActions from "../MaerskActions";
import { ActivityStatusEnum } from "../../../enums/activity.enum";
import { Activity } from "../../../models/activity.model";
import CreateInvoiceButton from "../CreateInvoiceButton";
import ContainerService from "../../../services/ContainerService/container.service";

interface CustomerRepairListProps {
  exportVisible?: boolean;
  exportLoading?: boolean;
  imageExportVisible?: boolean;
  imageExportLoading?: boolean;
  isAdmin: boolean;
  values?: any;
  approveVisible?: boolean;
  exportHandler?: (versionId?: number) => void;
  exportImagesHandler?: (versionId?: number) => void;
  approveClickHandler?: () => void;
  filtersApplyHandler: (formikValues: FormikValues) => void;
  isMaersk?: boolean;
  selectedRowKeys?:number[],
  handleOnMaeskSuccess?:()=>void,
  activityStatus?:string,
  selectedRowsData?:Activity[],
  handleSendEmailQuote?:(isImage?:boolean)=>void,
  emailQuoteLoading?:boolean
}

const ContainerTableActions = (props: CustomerRepairListProps) => {
  const {
    isAdmin,
    exportVisible = false,
    exportLoading = false,
    imageExportVisible = false,
    imageExportLoading = false,
    approveVisible = false,
    exportHandler = () => {},
    exportImagesHandler = () => {},
    approveClickHandler = () => {},
    filtersApplyHandler,
    values,
    isMaersk,
    selectedRowKeys,
    handleOnMaeskSuccess,
    selectedRowsData,
    handleSendEmailQuote,
    emailQuoteLoading
  } = props;
  


  const [yards, setYards] = useState<MetaModel[]>([]);

  const [customers, setCustomers] = useState<MetaModel[]>([]);

  const filters = [
    {
      title: "Date",
      name: "date",
      field: "date",
      options: [],
    },
    {
      title: "Activity",
      name: "activity_type",
      options: ActivityTypes,
    },
    {
      title: "Status",
      name: "activity_status",
      options: ActivityStatus,
    },
    {
      title: "Yard",
      name: "yard_id",
      options: yards,
    },
    {
      title: "Customer",
      name: "customer_id",
      disabled: !isAdmin,
      options: customers,
    },
  ] as FilterData[];

  const { fetchMeta } = MetaService();

  useEffect(() => {
    fetchMeta(ApiRoutes.YARDS, setYards, "yards");
    isAdmin &&
      fetchMeta(
        ApiRoutes.ALL_ACTIVE_CUSTOMERS,
        customerDataMapper,
        "customers"
      );
  }, []);

  const customerDataMapper = (customers: MetaModel[]) => {
    setCustomers(
      customers.map((customer) => ({
        value: customer.value,
        label: customer.customerName,
      }))
    );
  };
  
  const isAnyQuoteReadyToSend = (activities: Activity[] = []) => {
  const hasQuoteReadyToSend = activities.some(
    (item) => item.activityStatus === ActivityStatusEnum.QUOTE_READY_TO_SEND
  );

  return hasQuoteReadyToSend;
};

 const isAnyStatusReadyToSend = (activities: Activity[] = []) => {
  const hasQuoteReadyToSend = activities.some(
    (item) => item.activityStatus === ActivityStatusEnum.QUOTE_SENT_TO_CUSTOMER || item.activityStatus === ActivityStatusEnum.INVOICE_SENT_TO_CUSTOMER
  );

  return hasQuoteReadyToSend;
};



  return (
    <Row
      className="container__table-header"
      justify="space-between"
      wrap={false}
    >
      <Col>
        <Row wrap={false} gutter={10}>
          <Col>
            <TableSearchFilterComponent
              name="containers-list-filters"
              filterHandler={filtersApplyHandler}
              placeholder="Search container by number"
              filters={filters}
              values={values}
            />
          </Col>
          {exportVisible && (
            <Col>
              <Row gutter={10} wrap={false}>
                <Col>
                  <ButtonComponent
                    className="search-bar--trigger"
                    iconClass="icon-export"
                    text="Export"
                    loading={exportLoading}
                    onClick={exportHandler}
                  />
                </Col>
              </Row>
            </Col>
          )}
          {imageExportVisible && (
            <Col>
              <Row gutter={10} wrap={false}>
                <Col>
                  <ButtonComponent
                    className="search-bar--trigger"
                    iconClass="icon-export"
                    text="Export Images"
                    loading={imageExportLoading}
                    onClick={exportImagesHandler}
                  />
                </Col>
              </Row>
            </Col>
          )}
          {isMaersk ? (
            <>
              <MaerskActions
                selectedRowKeys={selectedRowKeys??[]}
                quoteSpan={13}
                statusSpan={8}
                onMaeskActionSuccess={handleOnMaeskSuccess}
                 showQuoteBtn={isAnyQuoteReadyToSend(selectedRowsData)}
                 showUpdateStatus={isAnyStatusReadyToSend(selectedRowsData)}
              />
            </>
          ):
          
       selectedRowKeys && selectedRowKeys?.length >0 && <CreateInvoiceButton
        primaryBtnLoading={!!emailQuoteLoading}
        primaryBtnText="Email Quote"
        iconClass="icon-mail"
        primaryBtnOnClick={()=>handleSendEmailQuote?.()}
        buttonType="default"
        dropdownButtons={[
           {
            text: "Without Images",
              onClick: () => {handleSendEmailQuote?.()},
          },
          {
            text: "With Images",
            onClick: () => {handleSendEmailQuote?.(true)},
          },
         
        ]}
      />
          
          }
        </Row>
      </Col>
      {approveVisible && (
        <Col>
          <ButtonComponent
            type="primary"
            text="Approve Quote"
            onClick={approveClickHandler}
          />
        </Col>
      )}
    </Row>
  );
};

export default ContainerTableActions;
